import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useHistory } from "react-router-dom";
import { auth } from "../../Authentication/firebase/firebase";
import API_Root from "../../Constants/API_Root"; 
import { doSignOut } from "../../Authentication/firebase/auth";
import { toggleToast } from "../../Actions/ToggleToast";
import { useDispatch } from "react-redux";
import {authFetch} from "../../Authentication/authService";

const SIDEBAR_WIDTH = 250;

function Support() {
  const dispatch = useDispatch();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const [hoveredItem, setHoveredItem] = useState(null);
  const history = useHistory();
  const [userEmail, setUserEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [discription, setDiscription] = useState("");
  const [website, setWebsite] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

    useEffect(() => {
      const unsubscribe = auth.onAuthStateChanged((user) => {
        if (user) {
          setUserEmail(user.email);
        } else {
          setUserEmail("");
        }
      });
  
      return () => unsubscribe();
    }, []);

      // 👉 PROCESS API RESPONSE HERE
const postSupportQuery = async (e) => {
  e.preventDefault();
  setLoading(true);
  setSuccessMsg("");

  const payload = {
    full_name: fullName,
    username: userEmail,
    email: email,
    company_website: website,
    subject: subject,
    description: discription,
  };

  try {
    const res = await authFetch(API_Root + "users/raise-ticket", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    setSuccessMsg("Your request has been submitted successfully!");
    
    // Reset fields
    setFullName("");
    setSubject("");
    setEmail("");
    setDiscription("");
    setWebsite("");

  } catch (error) {
    console.error("Error:", error);
    setSuccessMsg("Something went wrong. Please try again.");
  }

  setLoading(false);
};

  // Detect screen size changes
  useEffect(() => {
    const resize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const containerStyle = {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    // marginTop: "10px",
  };

  const labelStyle = {
    fontWeight: "500",
    marginBottom: "5px",
  };

  // Sidebar Style
  const sidebarStyle = {
    width: SIDEBAR_WIDTH,
    minHeight: "100vh",
    backgroundColor: "#f8f9fa",
    borderRight: "1px solid #e0e0e0",
    padding: "20px",
    position: isDesktop ? "relative" : "fixed",
    top: 0,
    left: isDesktop ? 0 : sidebarOpen ? 0 : -SIDEBAR_WIDTH,
    transition: "left 0.3s ease",
    zIndex: 1000,
  };

  const contentStyle = {
    // marginLeft: isDesktop ? SIDEBAR_WIDTH : 0,
    width: "100%",
    transition: "margin-left 0.3s ease",
  };

  const overlayStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.3)",
    display: !isDesktop && sidebarOpen ? "block" : "none",
    zIndex: 999,
  };

  const navItemStyle = {
    padding: "10px 15px",
    borderRadius: "6px",
    cursor: "pointer",
    marginBottom: "5px",
  };

  const activeNavItemStyle = {
    ...navItemStyle,
    backgroundColor: "#000",
    color: "#fff",
  };

  const getHoverStyle = (item) => ({
    ...navItemStyle,
    backgroundColor: hoveredItem === item ? "#e6e6e6" : "transparent",
  });

  const AccountPage = () => {
    history.push("/profile");
  };

  const ShopPage = () => {
    history.push("/shops");
  };

  const ProductPage = () => {
    history.push("/myproduct");
  }

  const TrainingPage = () => {
    history.push("/training")
  }

  const ActivityPage = () => history.push("/activity");

  const handleLogout = () => {
    doSignOut()
      .then(() => {
        localStorage.removeItem("isLoggedIn");
        history.push("/");
      })
      .catch(() => {
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Logout failed",
          })
        );
      });
  };

  return (
    <div className="container-fluid p-0">
      {/* Overlay for mobile */}
      <div style={overlayStyle} onClick={() => setSidebarOpen(false)} />

      <div className="d-flex">
        {/* Sidebar */}
        <div style={sidebarStyle}>
          <h5 className="fw-bold mb-4 d-flex justify-content-between align-items-center">
            E&S Solutions
            {!isDesktop && (
              <i
                className="bi bi-x-lg d-md-none"
                style={{ cursor: "pointer" }}
                onClick={() => setSidebarOpen(false)}
              ></i>
            )}
          </h5>

          <div
            style={getHoverStyle("My Products")}
            onMouseEnter={() => setHoveredItem("My Products")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={ProductPage}
          >
            My Products
          </div>

          <div
            style={getHoverStyle("Shop / Marketplace")}
            onMouseEnter={() => setHoveredItem("Shop / Marketplace")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={ShopPage}
          >
            Shop / Marketplace
          </div>

          <div
            style={getHoverStyle("E&S Solutions Training Centre")}
            onMouseEnter={() => setHoveredItem("E&S Solutions Training Centre")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={TrainingPage}
          >
            E&S Solutions Training Centre
          </div>

          <div style={activeNavItemStyle}>Support & Help</div>

          <div
            style={getHoverStyle("Account Settings")}
            onMouseEnter={() => setHoveredItem("Account Settings")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={AccountPage}
          >
            Account Settings
          </div>

          {/* <div
            style={getHoverStyle("Community & Resources")}
            onMouseEnter={() => setHoveredItem("Community & Resources")}
            onMouseLeave={() => setHoveredItem(null)}
          >
            Community & Resources
          </div> */}

          <div
            style={getHoverStyle("Activity Log")}
            onMouseEnter={() => setHoveredItem("Activity Log")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={ActivityPage}
          >
            Activity Log
          </div>
        </div>

        {/* Main Content */}
        <div style={contentStyle}>
          {/* Top Bar */}
          <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
            {!isDesktop && (
              <i
                className="bi bi-list fs-3"
                style={{ cursor: "pointer" }}
                onClick={() => setSidebarOpen(true)}
              ></i>
            )}
            <h4 className="fw-bold m-0">Support & Help</h4>
            <div>
            <button
            className="me-2"
            onClick={handleLogout}
            style={{
              border: "1px solid black",
              backgroundColor: "transparent",
              cursor: "pointer",
              padding: '5px',
              transition: "all 0.3s ease",
              fontSize: "small",
            }}
          >
            Logout
          </button>
              <i className="bi bi-bell me-3"></i>
              <img
                src="https://alpha.essolutions.ai/static/media/newlogo.b86cf5045d46267faf39.png"
                alt="Profile"
                width={"20px"}
                className="rounded-circle"
              />
            </div>
          </div>

          <div
            className="p-4"
            style={{ maxWidth: "100%", overflowX: "hidden" }}
          >
            <div style={containerStyle}>
              {/* from here --   */}
              <div className="container-fluid">
                {/* FAQ Section */}
                <div className="mb-4">
                  <h5 className="fw-bold mb-3">Frequently Asked Questions</h5>

                  <div className="border-bottom py-3">
                    <details open>
                      <summary
                        className="fw-semibold"
                        style={{ cursor: "pointer" }}
                      >
                        How do I renew my license?
                      </summary>
                      <p
                        className="mt-2 text-muted"
                        style={{ fontSize: "14px" }}
                      >
                        To renew your license, go to My Products from your
                        dashboard and select the product you want to renew.
                        Click <strong>Manage Subscription</strong>, then choose
                        the <strong>Renew License</strong> option. You'll be
                        able to review your current plan, update billing details
                        if needed, and confirm the renewal. Once renewed, you'll
                        receive a confirmation email along with an updated
                        invoice and the new expiry date will reflect
                        automatically in your product dashboard.
                      </p>
                    </details>
                  </div>

                  <div className="border-bottom py-3">
                    <details>
                      <summary
                        className="fw-semibold"
                        style={{ cursor: "pointer" }}
                      >
                        Where can I download invoices?
                      </summary>
                    </details>
                  </div>

                  <div className="border-bottom py-3">
                    <details>
                      <summary
                        className="fw-semibold"
                        style={{ cursor: "pointer" }}
                      >
                        How do I report a technical issue?
                      </summary>
                    </details>
                  </div>
                </div>

                <hr style={{ borderTop: "2px dotted #007bff" }} />

                {/* Submit a Ticket Form */}
                <div className="mt-4">
                  <h5 className="fw-bold mb-3">Submit a Ticket Form or Reach out to your dedicated contact person or email us at info@essolutions.ai</h5>

           <form className="row g-3" onSubmit={postSupportQuery}>
  <div className="col-md-6">
    <label className="form-label fw-semibold">Full Name</label>
    <input
      type="text"
      className="form-control"
      placeholder="Full Name"
      value={fullName}
      onChange={(e) => setFullName(e.target.value)}
    />
  </div>

  <div className="col-md-6">
    <label className="form-label fw-semibold">Subject</label>
    <input
      type="text"
      className="form-control"
      placeholder="Enter subject"
      value={subject}
      onChange={(e) => setSubject(e.target.value)}
    />
  </div>

  <div className="col-md-6">
    <label className="form-label fw-semibold">Email</label>
    <input
      type="email"
      className="form-control"
      placeholder="Companies Email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
    />
  </div>

  <div className="col-md-6">
    <label className="form-label fw-semibold">Description</label>
    <input
      type="text"
      className="form-control"
      placeholder="Describe your issue"
      value={discription}
      onChange={(e) => setDiscription(e.target.value)}
    />
  </div>

  <div className="col-md-6">
    <label className="form-label fw-semibold">Company's Website</label>
    <input
      type="text"
      className="form-control"
      placeholder="Company Website"
      value={website}
      onChange={(e) => setWebsite(e.target.value)}
    />
  </div>

  <div className="col-md-6 d-flex align-items-end justify-content-end">
    <button
      type="submit"
      className="btn btn-dark"
      style={{ borderRadius: "8px", padding: "8px 20px" }}
      disabled={loading}
    >
      {loading ? "Submitting..." : "Submit Request"}
    </button>
  </div>

  {successMsg !== "" && (
    <div className="col-12">
      <div className="alert alert-success mt-3">{successMsg}</div>
    </div>
  )}
</form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;
